import { AxiosGet } from './client';

export async function getPage({
  handle,
  page = 1,
}) {
  return await AxiosGet(`/collections/${handle}?page=${page}&view=api`);
}